// Importe i18next pour la gestion des traductions
import i18n from 'i18next';
// Importe initReactI18next pour l'intégration avec React
import { initReactI18next } from 'react-i18next';
// Importe LanguageDetector pour détecter la langue du navigateur
import LanguageDetector from 'i18next-browser-languagedetector';

import HttpBackend from 'i18next-http-backend'; // 👈 nouvelle ligne

const namespaces = [
    'auth',
    'datatable',
    'identification',
    'common',
    // 'dashboard'
]; // Liste des namespaces de traduction

// Configure i18next
i18n
    .use(HttpBackend) // 👈 active le backend
    // Utilise le détecteur de langue du navigateur
    .use(LanguageDetector)
    // Passe l'instance i18n à react-i18next
    .use(initReactI18next)
    // Initialise i18next avec les options de configuration
    .init({
        // Langues de fallback si une traduction n'est pas trouvée
        fallbackLng: 'fr', // Langue de secours par défaut : français
        // Options de débogage (utile en développement)
        debug: false,
        // Options pour les ressources de traduction
        // resources: {
        //     // Les traductions seront chargées dynamiquement depuis public/locales
        //     // C'est une configuration par défaut pour le chargement des fichiers JSON
        // },
        // Options pour le détecteur de langue
        detection: {
            // Ordre dans lequel les langues sont détectées
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            // Nom de la clé dans le stockage local ou les cookies
            caches: ['localStorage', 'cookie'],
        },
        // Options pour le formattage des clés (par exemple, pour la mise en majuscules)
        interpolation: {
            escapeValue: false, // React échappe déjà les valeurs, donc pas besoin de le faire ici
        },
        // Chemin pour charger les traductions (utilisé par i18next-http-backend si configuré)
        // Pour cette configuration simple, nous allons les charger manuellement via public/locales
        ns: namespaces, // Spécifie les namespaces à utiliser
        defaultNS: 'common', // Namespace par défaut
        react: {
            useSuspense: true, // Utilise Suspense pour le chargement des traductions
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
    });
export default i18n 
